import { API_URLS } from "@/constants/urls"
import { apiClient } from "./apiClient"
import axios from "axios"

export const logsServices = {
    getRunLogs: async (page, page_size) => {
        const result = await apiClient.get(API_URLS.RUN_LOGS, {
            params: {
                page: page,
                page_size: page_size
            }
        })
        return result.data
    },

    getSchedules: async () => {
        const result = await apiClient.get(API_URLS.SCHEDULE_LOGS)
        return result.data
    },

    getInvoices: async () => {
        const result = await apiClient.get(API_URLS.PAYMENT_HISTORY)
        return result.data
    },

    getIpInfo: async () => {
        return (await axios.get("https://ipapi.co/json/")).data
    }

}

